import { render, staticRenderFns } from "./BetaIcon.vue?vue&type=template&id=5c190996"
import script from "./BetaIcon.vue?vue&type=script&lang=js"
export * from "./BetaIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports